import { defineComponent as _defineComponent } from 'vue'
import type { TabType } from '@/interfaces/inner-tabs';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';

import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { useFilterStore } from '@/stores/pinia/useFilterStore';

import { useRouter } from 'vue-router/composables';
import { isNavigationFailure, NavigationFailureType } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'WatchlistInnerTabNavigation',
  props: {
    tabs: null,
    selectedTab: null,
    trackingLabel: { default: 'list_types' }
  },
  emits: ["scrollToTop"],
  setup(__props: any, { emit }: { emit: ({ (event: 'scrollToTop'): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { tabs: Array<{
			key: TabType;
			translation: string;
		}>, selectedTab: TabType, trackingLabel: string };



const { setFilterValue } = useFilterStore();
const router = useRouter();



function onTabClick(tab: TabType) {
	router
		.replace({ query: { ...router.currentRoute.query, inner_tab: tab, list_id: undefined } })
		.catch((error: any) => {
			if (
				!isNavigationFailure(error, NavigationFailureType.duplicated) &&
				!isNavigationFailure(error, NavigationFailureType.cancelled)
			) {
				throw error;
			}
		});

	setFilterValue({
		filterName: 'inner_tab',
		filterValue: tab,
		updateRouteState: false,
	});

	emit('scrollToTop');

	TrackingHelper.trackEvent('userinteraction', {
		action: 'filter_toggled',
		label: props.trackingLabel,
		property: tab,
	});
}

return { __sfc: true,props, setFilterValue, router, emit, onTabClick, HiddenHorizontalScrollbar }
}

})